<!-- them ten nhom -->
<form #f="ngForm" (keydown.enter)="$event.preventDefault()"
  (ngSubmit)="!f.form.valid? accordion.openAll() : 'true' && f.form.valid && onCreateSave(grUs.name)">

  <mat-card>
    <mat-card-header>
      <mat-card-title>{{'breadcrumbs.enterprise_decentralization_group_user' | translate}}
        <!-- <small class="form-text text-gray pull-left pb-2 float-right">(<span style="color: red;">*</span>) {{'form.info'
          | translate}}</small> -->
      </mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <mat-accordion #accordion="matAccordion" [multi]="true">
        <mat-expansion-panel class="mt-3" expanded=true>
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title">
              {{'title.group_user_info' | translate}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row">
            <div class="col-sm-12">
              <small>{{'search_form.group_name' | translate}}</small>
              <p class="dotted">{{grUs.name}}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <small>{{'headertable.description' | translate}}</small>
              <p class="dotted">{{grUs.description}}</p>
            </div>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel class="mt-3 mb-3" expanded=true>
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title">
              {{'user_group.decentralization' | translate}}
            </mat-panel-title>
            <mat-panel-description>
              <!-- description -->
            </mat-panel-description>
          </mat-expansion-panel-header>
          <nz-tabset (nzSelectedIndexChange)="selectedIndexChange($event)" style="margin-top: -1rem;" class="tab-role">
            <!-- chuc nang -->
            <nz-tab nzTitle="{{'user_group.decentralization_by_function' | translate}}">
              <div class="row m-0 checkbox-feature">
                <div class="col-12">
                  <div class="mb-2 bold">
                    <mat-checkbox [disabled]="getPermisionSME" color="primary" [(ngModel)]="checkAll" (change)="checkAllPermission()"
                      name="checkAll">
                      {{'form.choose_all' | translate}}
                    </mat-checkbox>
                  </div>
                  <div class="mb-2" *ngFor="let group of dataRole; let i = index">
                    <ng-container *ngIf="group.code != 'ae.qlshhd' && group.code != 'ae.qlhdct.gh' && noIncludePermissions(group.code)">
                      <ng-container *ngIf="group.code === 'ae.qlhdct' && group.active; else normalOption">
                        <div [ngClass]="group.code.includes('40') ? 'ml-4 permission-customer' : 'bold'" style="display: flex; justify-content: space-between;">
                          <mat-checkbox [disabled]="getPermisionSME" color="primary" [(ngModel)]="group.active" name="active" [indeterminate]="group.code.includes('ae.qlttkh') && checkIndeterminate()"
                            [ngModelOptions]="{standalone: true}" (change)="permissionChanged(group)">
                            {{ 'feature-group.' + group.code | translate}}
                          </mat-checkbox>
                        </div>
                        <div style="height: 12.5px;"></div>
                        <div class="mat-error" *ngIf="showCreateSideError">
                          <span class="text-error">{{ 'validation.service_type_auth_required' | translate }}</span>
                        </div>
                      </ng-container>
                      <ng-template #normalOption>
                        <div [ngClass]="group.code.includes('40') ? ( (group.code == '406.xmnkh' || group.code == '402.xdskh') ? 'ml-5 permission-customer' : 'ml-4 permission-customer') : 'bold'" style="display: flex; justify-content: space-between;">
                          <mat-checkbox [disabled]="getPermisionSME" color="primary" [(ngModel)]="group.active" name="active" [indeterminate]="(group.code.includes('ae.qlttkh') && checkIndeterminate()) || (group.code.includes('402.parent.406') && checkIndeterminate402())"
                            [ngModelOptions]="{standalone: true}" (change)="permissionChanged(group)">
                            {{ 'feature-group.' + group.code | translate}}
                          </mat-checkbox>
                        </div>
                        <div *ngIf="group.code == '406.xmnkh'" class="ml-5 customer_group_info" style="gap: 16px">
                          <button mat-raised-button (click)="viewGroupCusomer()" type="button" color="primary">
                            {{'new_permission_406.configure_customer_group' | translate}}
                          </button>
                          <div>{{'new_permission_406.configured_group_count' | translate}} {{dataListGroupCustomer.length}}</div>
                        </div>
                        <small class="form-text text-muted" style="padding-left: 25px; margin-bottom: -10px;">
                          <em *ngFor="let feture of group.child; last as isLast">{{ 'feature.' + feture.code | translate}}
                            <em *ngIf="!isLast">/ </em></em>
                        </small>
                        <fieldset class="pt-2">
                          <legend></legend>
                          <div class="row" *ngFor="let subPermission of group.subSignPermission">
                            <div class="col-12 ml-4">
                              <mat-checkbox [disabled]="getPermisionSME" color="primary" [ngModelOptions]="{standalone: true}"
                                [(ngModel)]="subPermission.active" name="subPermission.active"
                                (change)="subSignChange(group)">
                                {{subPermission.name}}
                              </mat-checkbox>
                            </div>
                          </div>
                        </fieldset>
                      </ng-template>
                    </ng-container>
                  </div>
                </div>
              </div>
            </nz-tab>
            <!-- dữ liệu hđ  -->
            <nz-tab nzTitle="{{'user_group.data_decentralization' | translate}}">
              <div class="ml-2 mt-1 w-100 border-bottom pb-3 font-weight-bold">
                <div class="d-flex align-items-center">
                  <div style="font-size: 15px; color:#000000DE" class="">{{'header.document_permission_create' | translate}}</div>
                  <div class="d-flex pl-2">
                    <div (click)="changeStatusCreateDocument(true)"
                      [ngClass]="isStatusCreateDocument ? 'status-document' : 'text-off-document'"
                      style="cursor: pointer; border-right: none; font-weight: 600; border: 1px solid #D9D9D9; padding: 2px 10px; border-bottom-left-radius: 3px; border-top-left-radius: 3px;">
                      {{'user_group.on_document' | translate}}</div>
                    <div (click)="changeStatusCreateDocument(false)"
                      [ngClass]="!isStatusCreateDocument ? 'status-document' : 'text-off-document'"
                      style="cursor: pointer; border-left: none; font-weight: 600; border: 1px solid #D9D9D9; padding: 2px 10px; border-bottom-right-radius: 3px; border-top-right-radius: 3px;">
                      {{'user_group.off_document' | translate}}</div>
                  </div>
                </div>
                <ng-container *ngIf="isStatusCreateDocument">
                  <p class="font-italic" style="font-size: 13.5px;
                    font-weight: normal;
                    color: black;
                    margin-top: 15px;
                    margin-bottom: -5px;">{{'user_group.message_note_permission_create_contract' | translate}}</p>
                    <div class="pl-4">
                      <div style="width: 50%;" class="mt-2">
                        <mat-form-field class="w-100">
                          <mat-label>{{'user_group.select_document' | translate}}</mat-label>
                          <mat-select #documentTypeSelect2 (focusout)="(checkFocus = true)"
                            (selectionChange)="checkFocus = false;"
                            (focus)="commonService.openComboBox(checkFocus, documentTypeSelect2)" id="id2" name="serviceType2"
                            [(ngModel)]="docTypeSelected2" #serviceType2="ngModel">
                            <mat-option>
                              <ngx-mat-select-search class="mat-select-doc-type"
                                [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                                [placeholderLabel]="'user_group.search_doc_type' | translate"
                                [formControl]="searchTypeCtrl2">
                              </ngx-mat-select-search>
                            </mat-option>
                            <ng-container
                              *ngIf="!isSelectAllDocType2 && isSearchOptionAllDocType2 && listFullServiceTypes.length">
                              <mat-option #allSelectedDocumentType2 (click)="clickOptiondocTypeAll2()">
                                {{ 'form.choose_all' | translate }}
                              </mat-option>
                            </ng-container>
                            <div class="service-type-loading" *ngIf="isServiceTypesLoading">
                              <i class="fa fa-circle-o-notch fa-spin"></i>
                            </div>
                            <mat-option class="select-service-type" *ngFor="let type of listTypes2" [value]="type"
                              (click)="clickOptiondocType2(type)">
                              {{type.code}} - {{ type.name }}
                            </mat-option>
                            <mat-option *ngIf="isSearchOptionVirtual2" style="display: none;"></mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div style="margin-top: -1rem;" class="d-flex flex-wrap">
                        <ng-container *ngIf="isSelectAllDocType2; else allTypeSelected2">
                          <div class="tag-select-all">
                            <div style="font-weight: 500;" class="chip-all" matTooltip="{{'user_group.select_all' | translate}}">
                              {{'user_group.select_all' | translate}}
                              <span class="material-icons" (click)="removeAllTags2()"> close </span>
                            </div>
                          </div>
                        </ng-container>
                        <ng-template #allTypeSelected2>
                          <div class="col-12 pb-2">
                            <div class="d-flex flex-wrap flex-gap-chip">
                              <div style="font-weight: 500;" class="chip" matTooltip="{{ item.code }} - {{item.name}}" *ngFor="let item of listTags2">
                                {{item.code}} -
                                {{item.name}}
                                <span class="material-icons" (click)="clickOptiondocType2(item)"> close </span>
                              </div>
                            </div>
                          </div>
                        </ng-template>
                      </div>
                    </div>
                </ng-container>
              </div>
              <div class="ml-2 mt-3 w-100 border-bottom pb-3 font-weight-bold">
                <div class="d-flex align-items-center">
                  <div style="font-size: 15px; color:#000000DE" class="">{{'header.document_permission_view' | translate}}</div>
                  <ng-container *ngIf=""></ng-container>
                  <div class="d-flex pl-2">
                    <div (click)="changeStatusDocument(true)"
                      [ngClass]="isStatusDocument ? 'status-document' : 'text-off-document'"
                      style="cursor: pointer; border-right: none; font-weight: 600; border: 1px solid #D9D9D9; padding: 2px 10px; border-bottom-left-radius: 3px; border-top-left-radius: 3px;">
                      {{'user_group.on_document' | translate}}</div>
                    <div (click)="changeStatusDocument(false)"
                      [ngClass]="!isStatusDocument ? 'status-document' : 'text-off-document'"
                      style="cursor: pointer; border-left: none; font-weight: 600; border: 1px solid #D9D9D9; padding: 2px 10px; border-bottom-right-radius: 3px; border-top-right-radius: 3px;">
                      {{'user_group.off_document' | translate}}</div>
                  </div>
                </div>
                <p *ngIf="isStatusDocument" class="font-italic" style="font-size: 13.5px;
                font-weight: normal;
                color: black;
                margin-top: 15px;
                margin-bottom: -5px;">{{'user_group.message_open_manage_contract' | translate}}</p>
              </div>
              <ng-container *ngIf="isStatusDocument">
                <div class="pl-4 tree-features">
                  <div style="width: 50%" class="mt-4">
                    <div class="mb-2" *ngFor="let group of dataRole; let i = index">
                      <ng-container *ngIf="group.code == 'ae.qlhdct.gh'">
                        <mat-checkbox color="primary" [(ngModel)]="group.active" name="active" class="bold"
                            [ngModelOptions]="{standalone: true}" (change)="permissionChanged(group)">
                            {{ 'feature-group.' + group.code | translate}}
                        </mat-checkbox>
                      </ng-container>
                    </div>
                  </div>
                  <div style="width: 50%" class="mt-2">
                    <!-- <mat-form-field class="w-100">
                      <mat-select id="type" name="type" [(ngModel)]="selectControl"
                        [placeholder]="'document_template.lbl_document_type' | translate"
                        (ngModelChange)="addTag($event)">
                        <mat-option>
                          <ngx-mat-select-search [formControl]="searchTypeCtrl"
                            noEntriesFoundLabel="{{'user_group.user_group_no_result' | translate}}"
                            placeholderLabel="{{'user_group.enter_type_doc' | translate}}">
                          </ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let type of listTypes" [value]="type">
                          {{type.code}} - {{ type.name }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field> -->
                    <mat-form-field class="w-100">
                      <mat-label>{{'user_group.select_document' | translate}}</mat-label>
                      <mat-select #documentTypeSelect (focusout)="(checkFocus = true)"
                        (selectionChange)="checkFocus = false;"
                        (focus)="commonService.openComboBox(checkFocus, documentTypeSelect)" id="id" name="serviceType"
                        [(ngModel)]="docTypeSelected" #serviceType="ngModel">
                        <mat-option>
                          <ngx-mat-select-search class="mat-select-doc-type" [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                            [placeholderLabel]="'user_group.search_doc_type' | translate"
                            [formControl]="searchTypeCtrl">
                          </ngx-mat-select-search>
                        </mat-option>
                        <ng-container *ngIf="!isSelectAllDocType && isSearchOptionAllDocType && listFullServiceTypes.length">
                          <mat-option #allSelectedDocumentType (click)="clickOptiondocTypeAll()">
                            {{ 'form.choose_all' | translate }}
                          </mat-option>
                        </ng-container>
                        <div class="service-type-loading" *ngIf="isServiceTypesLoading">
                          <i class="fa fa-circle-o-notch fa-spin"></i>
                        </div>
                        <mat-option class="select-service-type" *ngFor="let type of listTypes" [value]="type" (click)="clickOptiondocType(type)">
                          {{type.code}} - {{ type.name }}
                        </mat-option>
                        <mat-option *ngIf="isSearchOptionVirtual" style="display: none;"></mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div style="margin-top: -1rem;" class="d-flex flex-wrap">
                    <ng-container *ngIf="isSelectAllDocType; else allTypeSelected">
                      <div class="tag-select-all">
                        <div class="chip-all" matTooltip="{{'user_group.select_all' | translate}}">
                          {{'user_group.select_all' | translate}}
                          <span class="material-icons" (click)="removeAllTags()"> close </span>
                        </div>
                      </div>
                    </ng-container>
                    <ng-template #allTypeSelected>
                      <div class="col-12 pb-2">
                        <div class="d-flex flex-wrap flex-gap-chip">
                          <div class="chip"
                               *ngFor="let item of listTags"
                          >
                          {{item.code}} -
                          {{item.name}}
                            <span class="material-icons" (click)="clickOptiondocType(item)"> close </span>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </div>

                  <div class="font-weight-bold mt-2" style="color: #000000DE;">
                    {{'user_group.select_user_allow_connect_data' | translate}}
                  </div>

                  <div style="width: 50% !important; margin-bottom: -1.25rem;"
                    class="form-search-tree position-relative">
                    <mat-form-field class="mat-full-width">
                      <div class="position-absolute" style="top: 9px; left: -22px; cursor: pointer;">
                        <mat-icon (click)="searchTree()" class="mr-0" style="font-weight: 900;">search</mat-icon>
                      </div>
                      <input type="text" #focusInput matInput [formControl]="treeFormControl"
                        (keyup.enter)="searchTree()" (focusout)="searchTree()"
                        [placeholder]="'user_group.search_tree' | translate" autocomplete="off">
                    </mat-form-field>
                  </div>

                  <ng-container *ngIf="isSearchDataEmpty;else displayTree">
                    <p class="text-center mt-2">{{'messages.data_not_found' | translate}}</p>
                  </ng-container>

                  <ng-template #displayTree>
                    <nz-tree nzBlockNode nzCheckable nzMultiple [nzData]="featuresTree"
                      [nzExpandedKeys]="defaultExpandedKeys" [nzBeforeDrop]="beforeDrop"
                      (nzCheckBoxChange)="onSelectNode($event)" [nzCheckedKeys]="defaultCheckedKeys"
                      (nzExpandChange)="expandParentNode($event)" [nzTreeTemplate]="nzTreeTemplate"></nz-tree>

                      <ng-template #nzTreeTemplate let-node>
                        <span class="w-100" style="max-height: 500px; overflow-y: auto; overflow-x: hidden;">
                          <!-- COMPANY -->
                          <ng-container
                            *ngIf="node.origin.type === 'COMPANY' || (node.origin.type === 'BRANCH' && enterpriseType === 'BRANCH')">
                            <span *ngIf="node.origin.isActive">
                              <svg style="display: inline-block; margin-top: -5px;" width="16" height="16"
                                viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3.5 15.5H0.5V8.5H1.5" stroke="#001737" stroke-linecap="round"
                                  stroke-linejoin="round" />
                                <path d="M5.5 10.5H7.5" stroke="#001737" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M5.5 12.5H7.5" stroke="#001737" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M5.5 8.5H7.5" stroke="#001737" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M8.5 3.5V1L15.5 3.5V15.5H3.5V5.5H9.5V15.333" stroke="#001737"
                                  stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M11.5 12.5V4.5" stroke="#001737" stroke-linecap="round"
                                  stroke-linejoin="round" />
                                <path d="M13.5 12.5V5.5" stroke="#001737" stroke-linecap="round"
                                  stroke-linejoin="round" />
                              </svg>
                            </span>
                            <span *ngIf="!node.origin.isActive">
                              <svg style="display: inline-block; margin-top: -5px;" width="16" height="16"
                                viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3.5 15.5H0.5V8.5H1.5" stroke="#919191" stroke-linecap="round"
                                  stroke-linejoin="round" />
                                <path d="M5.5 10.5H7.5" stroke="#919191" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M5.5 12.5H7.5" stroke="#919191" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M5.5 8.5H7.5" stroke="#919191" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M8.5 3.5V1L15.5 3.5V15.5H3.5V5.5H9.5V15.333" stroke="#919191"
                                  stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M11.5 12.5V4.5" stroke="#919191" stroke-linecap="round"
                                  stroke-linejoin="round" />
                                <path d="M13.5 12.5V5.5" stroke="#919191" stroke-linecap="round"
                                  stroke-linejoin="round" />
                              </svg>
                            </span>
                          </ng-container>
                          <!-- BRANCH -->
                          <ng-container *ngIf="node.origin.type === 'BRANCH' && enterpriseType === 'COMPANY'">
                            <span *ngIf="node.origin.isActive">
                              <svg style="display: inline-block; margin-top: -5px;" width="16" height="16"
                                viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_2415_1244)">
                                  <path d="M14.5 3.5L8 0.5L1.5 3.5" stroke="#001737" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                  <path d="M3.5 2.577V6.5" stroke="#001737" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                  <path d="M12.5 2.577V6.5" stroke="#001737" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                  <path d="M6.5 15.5V11.5H9.5V15.5H15.5V8.5H0.5V15.5H6.5Z" stroke="#001737"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                  <path d="M6.5 4.5V5.5" stroke="#001737" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                  <path d="M9.5 4.5V5.5" stroke="#001737" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                  <path d="M3.5 11.5V12.5" stroke="#001737" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                  <path d="M12.5 11.5V12.5" stroke="#001737" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                </g>
                                <defs>
                                  <clipPath id="clip0_2415_1244">
                                    <rect width="16" height="16" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </span>
                            <span *ngIf="!node.origin.isActive">
                              <svg style="display: inline-block; margin-top: -5px;" width="16" height="16"
                                viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_2415_1244)">
                                  <path d="M14.5 3.5L8 0.5L1.5 3.5" stroke="#919191" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                  <path d="M3.5 2.577V6.5" stroke="#919191" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                  <path d="M12.5 2.577V6.5" stroke="#919191" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                  <path d="M6.5 15.5V11.5H9.5V15.5H15.5V8.5H0.5V15.5H6.5Z" stroke="#919191"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                  <path d="M6.5 4.5V5.5" stroke="#919191" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                  <path d="M9.5 4.5V5.5" stroke="#919191" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                  <path d="M3.5 11.5V12.5" stroke="#919191" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                  <path d="M12.5 11.5V12.5" stroke="#919191" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                </g>
                                <defs>
                                  <clipPath id="clip0_2415_1244">
                                    <rect width="16" height="16" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </span>
                          </ng-container>
                          <!-- NODE_BETWEEN AND DEPARTMENT -->
                          <ng-container
                            *ngIf="node.origin.type === 'NODE_BETWEEN_BRANCH' || node.origin.type === 'NODE_BETWEEN_USER' || node.origin.type === 'DEPARTMENT'">
                            <span *ngIf="node.origin.isActive">
                              <svg style="display: inline-block; margin-top: -5px;" width="16" height="16"
                              viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <g clip-path="url(#clip0_2415_1105)">
                                <path d="M3.5 7.5V0.5H12.5V5.5" stroke="#001737" stroke-linecap="round"
                                  stroke-linejoin="round" />
                                <path d="M6.5 9.5H0.5V15.5H6.5V9.5Z" stroke="#001737" stroke-linecap="round"
                                  stroke-linejoin="round" />
                                <path d="M15.5 7.5H9.5V15.5H15.5V7.5Z" stroke="#001737" stroke-linecap="round"
                                  stroke-linejoin="round" />
                                <path d="M2.5 12.5H4.5" stroke="#001737" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M11.5 10.5H13.5" stroke="#001737" stroke-linecap="round"
                                  stroke-linejoin="round" />
                                <path d="M11.5 12.5H13.5" stroke="#001737" stroke-linecap="round"
                                  stroke-linejoin="round" />
                                <path d="M6.5 15.5H9.5" stroke="#001737" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M6.5 3.5H9.5" stroke="#001737" stroke-linecap="round" stroke-linejoin="round" />
                              </g>
                              <defs>
                                <clipPath id="clip0_2415_1105">
                                  <rect width="16" height="16" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                            </span>
                            <span *ngIf="!node.origin.isActive">
                              <svg style="display: inline-block; margin-top: -5px;" width="16" height="16"
                              viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <g clip-path="url(#clip0_2415_1105)">
                                <path d="M3.5 7.5V0.5H12.5V5.5" stroke="#919191" stroke-linecap="round"
                                  stroke-linejoin="round" />
                                <path d="M6.5 9.5H0.5V15.5H6.5V9.5Z" stroke="#919191" stroke-linecap="round"
                                  stroke-linejoin="round" />
                                <path d="M15.5 7.5H9.5V15.5H15.5V7.5Z" stroke="#919191" stroke-linecap="round"
                                  stroke-linejoin="round" />
                                <path d="M2.5 12.5H4.5" stroke="#919191" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M11.5 10.5H13.5" stroke="#919191" stroke-linecap="round"
                                  stroke-linejoin="round" />
                                <path d="M11.5 12.5H13.5" stroke="#919191" stroke-linecap="round"
                                  stroke-linejoin="round" />
                                <path d="M6.5 15.5H9.5" stroke="#919191" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M6.5 3.5H9.5" stroke="#919191" stroke-linecap="round" stroke-linejoin="round" />
                              </g>
                              <defs>
                                <clipPath id="clip0_2415_1105">
                                  <rect width="16" height="16" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                            </span>
                          </ng-container>
                          <!-- USER -->
                          <ng-container *ngIf="node.origin.type === 'USER'">
                            <span *ngIf="node.origin.isActive">
                              <svg style="display: inline-block; margin-top: -5px;" width="16" height="16"
                                viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                  d="M14.5 12.976C14.5002 12.8151 14.4616 12.6566 14.3874 12.5138C14.3132 12.3711 14.2057 12.2483 14.074 12.156C12.2699 10.9877 10.1474 10.409 8 10.5C5.85262 10.409 3.73005 10.9877 1.926 12.156C1.79427 12.2483 1.68677 12.3711 1.61261 12.5138C1.53844 12.6566 1.49982 12.8151 1.5 12.976V15.5H14.5V12.976Z"
                                  stroke="#001737" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                  d="M8 7.5C9.933 7.5 11.5 5.933 11.5 4C11.5 2.067 9.933 0.5 8 0.5C6.067 0.5 4.5 2.067 4.5 4C4.5 5.933 6.067 7.5 8 7.5Z"
                                  stroke="#001737" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            </span>
                            <span *ngIf="!node.origin.isActive">
                              <svg style="display: inline-block; margin-top: -5px;" width="16" height="16"
                                viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                  d="M14.5 12.976C14.5002 12.8151 14.4616 12.6566 14.3874 12.5138C14.3132 12.3711 14.2057 12.2483 14.074 12.156C12.2699 10.9877 10.1474 10.409 8 10.5C5.85262 10.409 3.73005 10.9877 1.926 12.156C1.79427 12.2483 1.68677 12.3711 1.61261 12.5138C1.53844 12.6566 1.49982 12.8151 1.5 12.976V15.5H14.5V12.976Z"
                                  stroke="#919191" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                  d="M8 7.5C9.933 7.5 11.5 5.933 11.5 4C11.5 2.067 9.933 0.5 8 0.5C6.067 0.5 4.5 2.067 4.5 4C4.5 5.933 6.067 7.5 8 7.5Z"
                                  stroke="#919191" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            </span>
                          </ng-container>
                          <span matTooltip="{{ node.title }}"
                            [ngClass]="node.origin.isActive ? 'color-text-tree-active font-weight-bold' : 'color-text-tree-inactive font-italic font-weight-normal'"
                            class="position-absolute d-inline-block text-truncate {{node.origin.type === 'TYPE_VIRTUAL' ? 'hide-class' : ''}}"
                            style="margin-left: 10px; width: 85%;">{{ node.title }}</span>
                        </span>
                      </ng-template>
                  </ng-template>
                </div>
                <span style="display: inline-block; color: #333333;" class="pl-2 mt-4 mb-2">
                  <span>{{'user_group.note_tree' | translate}}</span>
                  <span
                    style="color: #919191 !important; font-weight: normal; font-style: italic; padding: 0 5px;">"{{'user_group.branch_department_user'
                    | translate}}"</span>
                  <span>- {{'user_group.inactive' | translate}}</span>
                </span>
              </ng-container>
            </nz-tab>
            <!-- dữ liệu số hóa  -->
            <nz-tab nzTitle="{{'user_group.digital_decentralization' | translate}}" *ngIf="isShowDigitalContract">
              <div class="ml-2 mt-1 w-100 pb-3 font-weight-bold">
                <div class="d-flex align-items-center">
                  <div style="font-size: 15px; color:#000000DE" class="">{{'header.use_digital' | translate}}</div>
                  <div class="d-flex pl-2">
                    <div (click)="changeStatusDigital(true)"
                      [ngClass]="isStatusDigital ? 'status-document' : 'text-off-document'"
                      style="cursor: pointer; border-right: none; font-weight: 600; border: 1px solid #D9D9D9; padding: 2px 10px; border-bottom-left-radius: 3px; border-top-left-radius: 3px;">
                      {{'user_group.on_document' | translate}}</div>
                    <div (click)="changeStatusDigital(false)"
                      [ngClass]="!isStatusDigital ? 'status-document' : 'text-off-document'"
                      style="cursor: pointer; border-left: none; font-weight: 600; border: 1px solid #D9D9D9; padding: 2px 10px; border-bottom-right-radius: 3px; border-top-right-radius: 3px;">
                      {{'user_group.off_document' | translate}}</div>
                  </div>
                  <div class="font-italic" style="font-size: 13.5px;
                  font-weight: normal;
                  color: black;
                  margin-left: 8px;">{{'user_group.message_open_manage_digital' | translate}}</div>
                </div>
              </div>
              <ng-container *ngIf="isStatusDigital">
                <div class="ml-2 mt-1 w-100 pb-3 font-weight-bold">
                  <div class="d-flex align-items-center">
                    <div style="font-size: 15px; color:#000000DE" class="">{{'user_group.dataManagement' | translate}}</div>
                    <div class="d-flex pl-2">
                      <div (click)="changeStatusDataDigital(true)"
                        [ngClass]="isStatusDataDigital ? 'status-document' : 'text-off-document'"
                        style="cursor: pointer; border-right: none; font-weight: 600; border: 1px solid #D9D9D9; padding: 2px 10px; border-bottom-left-radius: 3px; border-top-left-radius: 3px;">
                        {{'user_group.on_document' | translate}}</div>
                      <div (click)="changeStatusDataDigital(false)"
                        [ngClass]="!isStatusDataDigital ? 'status-document' : 'text-off-document'"
                        style="cursor: pointer; border-left: none; font-weight: 600; border: 1px solid #D9D9D9; padding: 2px 10px; border-bottom-right-radius: 3px; border-top-right-radius: 3px;">
                        {{'user_group.off_document' | translate}}</div>
                    </div>
                    <div class="font-italic" style="font-size: 13.5px;
                    font-weight: normal;
                    color: black;
                    margin-left: 8px;">{{'user_group.message_open_data_digital' | translate}}</div>
                  </div>
                </div>
                <div class="pl-4 tree-features" *ngIf="isStatusDataDigital">
                  <div class="font-weight-bold mt-2" style="color: #000000DE;">
                    {{'user_group.select_user_allow_connect_data' | translate}}
                  </div>

                  <div style="width: 50% !important; margin-bottom: -1.25rem;"
                    class="form-search-tree position-relative">
                    <mat-form-field class="mat-full-width">
                      <div class="position-absolute" style="top: 9px; left: -22px; cursor: pointer;">
                        <mat-icon (click)="searchTreeDigital()" class="mr-0" style="font-weight: 900;">search</mat-icon>
                      </div>
                      <input type="text" #focusInput matInput [formControl]="treeFormControlDigital"
                        (keyup.enter)="searchTreeDigital()" (focusout)="searchTreeDigital()"
                        [placeholder]="'user_group.search_tree' | translate" autocomplete="off">
                    </mat-form-field>
                  </div>

                  <ng-container *ngIf="isSearchDataDigitalEmpty;else displayTree">
                    <p class="text-center mt-2">{{'messages.data_not_found' | translate}}</p>
                  </ng-container>

                  <ng-template #displayTree>
                    <nz-tree nzBlockNode nzCheckable nzMultiple [nzData]="featuresTreeDigital"
                      [nzExpandedKeys]="defaultExpandedKeysDigital" [nzBeforeDrop]="beforeDrop"
                      (nzCheckBoxChange)="onSelectNodeDigital($event)" [nzCheckedKeys]="defaultCheckedKeysDigital"
                      (nzExpandChange)="expandParentNodeDigital($event)" [nzTreeTemplate]="nzTreeTemplateDigital"></nz-tree>

                      <ng-template #nzTreeTemplateDigital let-node>
                        <span class="w-100" style="max-height: 500px; overflow-y: auto; overflow-x: hidden;">
                          <!-- COMPANY -->
                          <ng-container
                            *ngIf="node.origin.type === 'COMPANY' || (node.origin.type === 'BRANCH' && enterpriseType === 'BRANCH')">
                            <span *ngIf="node.origin.isActive">
                              <svg style="display: inline-block; margin-top: -5px;" width="16" height="16"
                                viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3.5 15.5H0.5V8.5H1.5" stroke="#001737" stroke-linecap="round"
                                  stroke-linejoin="round" />
                                <path d="M5.5 10.5H7.5" stroke="#001737" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M5.5 12.5H7.5" stroke="#001737" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M5.5 8.5H7.5" stroke="#001737" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M8.5 3.5V1L15.5 3.5V15.5H3.5V5.5H9.5V15.333" stroke="#001737"
                                  stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M11.5 12.5V4.5" stroke="#001737" stroke-linecap="round"
                                  stroke-linejoin="round" />
                                <path d="M13.5 12.5V5.5" stroke="#001737" stroke-linecap="round"
                                  stroke-linejoin="round" />
                              </svg>
                            </span>
                            <span *ngIf="!node.origin.isActive">
                              <svg style="display: inline-block; margin-top: -5px;" width="16" height="16"
                                viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3.5 15.5H0.5V8.5H1.5" stroke="#919191" stroke-linecap="round"
                                  stroke-linejoin="round" />
                                <path d="M5.5 10.5H7.5" stroke="#919191" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M5.5 12.5H7.5" stroke="#919191" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M5.5 8.5H7.5" stroke="#919191" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M8.5 3.5V1L15.5 3.5V15.5H3.5V5.5H9.5V15.333" stroke="#919191"
                                  stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M11.5 12.5V4.5" stroke="#919191" stroke-linecap="round"
                                  stroke-linejoin="round" />
                                <path d="M13.5 12.5V5.5" stroke="#919191" stroke-linecap="round"
                                  stroke-linejoin="round" />
                              </svg>
                            </span>
                          </ng-container>
                          <!-- BRANCH -->
                          <ng-container *ngIf="node.origin.type === 'BRANCH' && enterpriseType === 'COMPANY'">
                            <span *ngIf="node.origin.isActive">
                              <svg style="display: inline-block; margin-top: -5px;" width="16" height="16"
                                viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_2415_1244)">
                                  <path d="M14.5 3.5L8 0.5L1.5 3.5" stroke="#001737" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                  <path d="M3.5 2.577V6.5" stroke="#001737" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                  <path d="M12.5 2.577V6.5" stroke="#001737" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                  <path d="M6.5 15.5V11.5H9.5V15.5H15.5V8.5H0.5V15.5H6.5Z" stroke="#001737"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                  <path d="M6.5 4.5V5.5" stroke="#001737" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                  <path d="M9.5 4.5V5.5" stroke="#001737" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                  <path d="M3.5 11.5V12.5" stroke="#001737" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                  <path d="M12.5 11.5V12.5" stroke="#001737" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                </g>
                                <defs>
                                  <clipPath id="clip0_2415_1244">
                                    <rect width="16" height="16" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </span>
                            <span *ngIf="!node.origin.isActive">
                              <svg style="display: inline-block; margin-top: -5px;" width="16" height="16"
                                viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_2415_1244)">
                                  <path d="M14.5 3.5L8 0.5L1.5 3.5" stroke="#919191" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                  <path d="M3.5 2.577V6.5" stroke="#919191" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                  <path d="M12.5 2.577V6.5" stroke="#919191" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                  <path d="M6.5 15.5V11.5H9.5V15.5H15.5V8.5H0.5V15.5H6.5Z" stroke="#919191"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                  <path d="M6.5 4.5V5.5" stroke="#919191" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                  <path d="M9.5 4.5V5.5" stroke="#919191" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                  <path d="M3.5 11.5V12.5" stroke="#919191" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                  <path d="M12.5 11.5V12.5" stroke="#919191" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                </g>
                                <defs>
                                  <clipPath id="clip0_2415_1244">
                                    <rect width="16" height="16" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </span>
                          </ng-container>
                          <!-- NODE_BETWEEN AND DEPARTMENT -->
                          <ng-container
                            *ngIf="node.origin.type === 'NODE_BETWEEN_BRANCH' || node.origin.type === 'NODE_BETWEEN_USER' || node.origin.type === 'DEPARTMENT'">
                            <span *ngIf="node.origin.isActive">
                              <svg style="display: inline-block; margin-top: -5px;" width="16" height="16"
                              viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <g clip-path="url(#clip0_2415_1105)">
                                <path d="M3.5 7.5V0.5H12.5V5.5" stroke="#001737" stroke-linecap="round"
                                  stroke-linejoin="round" />
                                <path d="M6.5 9.5H0.5V15.5H6.5V9.5Z" stroke="#001737" stroke-linecap="round"
                                  stroke-linejoin="round" />
                                <path d="M15.5 7.5H9.5V15.5H15.5V7.5Z" stroke="#001737" stroke-linecap="round"
                                  stroke-linejoin="round" />
                                <path d="M2.5 12.5H4.5" stroke="#001737" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M11.5 10.5H13.5" stroke="#001737" stroke-linecap="round"
                                  stroke-linejoin="round" />
                                <path d="M11.5 12.5H13.5" stroke="#001737" stroke-linecap="round"
                                  stroke-linejoin="round" />
                                <path d="M6.5 15.5H9.5" stroke="#001737" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M6.5 3.5H9.5" stroke="#001737" stroke-linecap="round" stroke-linejoin="round" />
                              </g>
                              <defs>
                                <clipPath id="clip0_2415_1105">
                                  <rect width="16" height="16" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                            </span>
                            <span *ngIf="!node.origin.isActive">
                              <svg style="display: inline-block; margin-top: -5px;" width="16" height="16"
                              viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <g clip-path="url(#clip0_2415_1105)">
                                <path d="M3.5 7.5V0.5H12.5V5.5" stroke="#919191" stroke-linecap="round"
                                  stroke-linejoin="round" />
                                <path d="M6.5 9.5H0.5V15.5H6.5V9.5Z" stroke="#919191" stroke-linecap="round"
                                  stroke-linejoin="round" />
                                <path d="M15.5 7.5H9.5V15.5H15.5V7.5Z" stroke="#919191" stroke-linecap="round"
                                  stroke-linejoin="round" />
                                <path d="M2.5 12.5H4.5" stroke="#919191" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M11.5 10.5H13.5" stroke="#919191" stroke-linecap="round"
                                  stroke-linejoin="round" />
                                <path d="M11.5 12.5H13.5" stroke="#919191" stroke-linecap="round"
                                  stroke-linejoin="round" />
                                <path d="M6.5 15.5H9.5" stroke="#919191" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M6.5 3.5H9.5" stroke="#919191" stroke-linecap="round" stroke-linejoin="round" />
                              </g>
                              <defs>
                                <clipPath id="clip0_2415_1105">
                                  <rect width="16" height="16" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                            </span>
                          </ng-container>
                          <!-- USER -->
                          <ng-container *ngIf="node.origin.type === 'USER'">
                            <span *ngIf="node.origin.isActive">
                              <svg style="display: inline-block; margin-top: -5px;" width="16" height="16"
                                viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                  d="M14.5 12.976C14.5002 12.8151 14.4616 12.6566 14.3874 12.5138C14.3132 12.3711 14.2057 12.2483 14.074 12.156C12.2699 10.9877 10.1474 10.409 8 10.5C5.85262 10.409 3.73005 10.9877 1.926 12.156C1.79427 12.2483 1.68677 12.3711 1.61261 12.5138C1.53844 12.6566 1.49982 12.8151 1.5 12.976V15.5H14.5V12.976Z"
                                  stroke="#001737" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                  d="M8 7.5C9.933 7.5 11.5 5.933 11.5 4C11.5 2.067 9.933 0.5 8 0.5C6.067 0.5 4.5 2.067 4.5 4C4.5 5.933 6.067 7.5 8 7.5Z"
                                  stroke="#001737" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            </span>
                            <span *ngIf="!node.origin.isActive">
                              <svg style="display: inline-block; margin-top: -5px;" width="16" height="16"
                                viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                  d="M14.5 12.976C14.5002 12.8151 14.4616 12.6566 14.3874 12.5138C14.3132 12.3711 14.2057 12.2483 14.074 12.156C12.2699 10.9877 10.1474 10.409 8 10.5C5.85262 10.409 3.73005 10.9877 1.926 12.156C1.79427 12.2483 1.68677 12.3711 1.61261 12.5138C1.53844 12.6566 1.49982 12.8151 1.5 12.976V15.5H14.5V12.976Z"
                                  stroke="#919191" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                  d="M8 7.5C9.933 7.5 11.5 5.933 11.5 4C11.5 2.067 9.933 0.5 8 0.5C6.067 0.5 4.5 2.067 4.5 4C4.5 5.933 6.067 7.5 8 7.5Z"
                                  stroke="#919191" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            </span>
                          </ng-container>
                          <span matTooltip="{{ node.title }}"
                            [ngClass]="node.origin.isActive ? 'color-text-tree-active font-weight-bold' : 'color-text-tree-inactive font-italic font-weight-normal'"
                            class="position-absolute d-inline-block text-truncate {{node.origin.type === 'TYPE_VIRTUAL' ? 'hide-class' : ''}}"
                            style="margin-left: 10px; width: 85%;">{{ node.title }}</span>
                        </span>
                      </ng-template>
                  </ng-template>
                  <span style="display: inline-block; color: #333333;" class="pl-2 mt-4 mb-2">
                    <span>{{'user_group.note_tree' | translate}}</span>
                    <span
                      style="color: #919191 !important; font-weight: normal; font-style: italic; padding: 0 5px;">"{{'user_group.branch_department_user'
                      | translate}}"</span>
                    <span>- {{'user_group.inactive' | translate}}</span>
                  </span>
                </div>

              </ng-container>
            </nz-tab>
            <!-- Phân quyền chia sẻ từ đối tác -->
            <nz-tab [nzTitle]="'contract_share_partner.partner_sharing_decentralization' | translate">
              <div class="ml-2 mt-1 w-100 border-bottom pb-3 font-weight-bold">
                <div class="d-flex align-items-center">
                  <div style="font-size: 15px; color:#000000DE;" class="">{{'contract_share_partner.partner_sharing_decentralization' | translate}}</div>
                  <div class="d-flex pl-2">
                    <div (click)="changeStatusSharePartner(true)"
                      [ngClass]="isStatusSharePartner ? 'status-document' : 'text-off-document'"
                      style="cursor: pointer; border-right: none; font-weight: 600; border: 1px solid #D9D9D9; padding: 2px 10px; border-bottom-left-radius: 3px; border-top-left-radius: 3px;">
                      {{'user_group.on_document' | translate}}</div>
                    <div (click)="changeStatusSharePartner(false)"
                      [ngClass]="!isStatusSharePartner ? 'status-document' : 'text-off-document'"
                      style="cursor: pointer; border-left: none; font-weight: 600; border: 1px solid #D9D9D9; padding: 2px 10px; border-bottom-right-radius: 3px; border-top-right-radius: 3px;">
                      {{'user_group.off_document' | translate}}</div>
                  </div>
                  <div class="font-italic" style="font-size: 13.5px;
                                font-weight: normal;
                                color: black;
                                margin-left: 8px;">{{'contract_share_partner.message_open_manage_contract_share' | translate}}</div>
                </div>
                <ng-container *ngIf="isStatusSharePartner">
                  <div class="pl-4 tree-features">
                    <div style="width: 50%" class="mt-4">
                      <div class="mb-2" *ngFor="let group of dataRole; let i = index">
                        <ng-container *ngIf="group.code == 'ae.qlhdcs.gh'">
                          <mat-checkbox color="primary" [(ngModel)]="group.active" name="active" class="bold"
                              [ngModelOptions]="{standalone: true}" (change)="permissionChanged(group)">
                              {{ 'feature-group.' + group.code | translate}}
                          </mat-checkbox>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </nz-tab>
             <!-- Phân quyền quản lý HĐLĐ  -->
             <nz-tab [nzTitle]="'contract_management_permissions.contract_management_permissions' | translate" *ngIf="!commonService.checkEnterpriseType()">
              <div class="ml-2 mt-1 w-100 border-bottom pb-3 font-weight-bold">
                <!-- Phân quyền chuẩn hóa HĐLĐ -->
                <div class="d-flex align-items-center">
                  <div style="font-size: 15px; color:#000000DE;" class="">{{'contract_management_permissions.contract_standardization_permissions' | translate}}</div>
                  <div class="d-flex pl-2">
                    <div (click)="changeStatusContractStandardization(true)"
                      [ngClass]="isStatusContractStandardization ? 'status-document' : 'text-off-document'"
                      style="cursor: pointer; border-right: none; font-weight: 600; border: 1px solid #D9D9D9; padding: 2px 10px; border-bottom-left-radius: 3px; border-top-left-radius: 3px;">
                      {{'user_group.on_document' | translate}}</div>
                    <div (click)="changeStatusContractStandardization(false)"
                      [ngClass]="!isStatusContractStandardization ? 'status-document' : 'text-off-document'"
                      style="cursor: pointer; border-left: none; font-weight: 600; border: 1px solid #D9D9D9; padding: 2px 10px; border-bottom-right-radius: 3px; border-top-right-radius: 3px;">
                      {{'user_group.off_document' | translate}}</div>
                  </div>
                  <div class="font-italic" style="font-size: 13.5px;
                    font-weight: normal;
                    color: black;
                    margin-left: 8px;">{{'contract_management_permissions.allows_users_convert_electronic' | translate}}</div>
                </div>

                <!-- Phân quyền quản lý bộ hồ sơ HĐLĐ -->
                <div class="d-flex align-items-center mt-2">
                  <div style="font-size: 15px; color:#000000DE;" class="">{{'contract_management_permissions.contract_dossier_management_permissions' | translate}}</div>
                  <div class="d-flex pl-2">
                    <div (click)="changeStatusContractDossier(true)"
                      [ngClass]="isStatusContractDossier ? 'status-document' : 'text-off-document'"
                      style="cursor: pointer; border-right: none; font-weight: 600; border: 1px solid #D9D9D9; padding: 2px 10px; border-bottom-left-radius: 3px; border-top-left-radius: 3px;">
                      {{'user_group.on_document' | translate}}</div>
                    <div (click)="changeStatusContractDossier(false)"
                      [ngClass]="!isStatusContractDossier ? 'status-document' : 'text-off-document'"
                      style="cursor: pointer; border-left: none; font-weight: 600; border: 1px solid #D9D9D9; padding: 2px 10px; border-bottom-right-radius: 3px; border-top-right-radius: 3px;">
                      {{'user_group.off_document' | translate}}</div>
                  </div>
                  <div class="font-italic" style="font-size: 13.5px;
                    font-weight: normal;
                    color: black;
                    margin-left: 8px;">{{'contract_management_permissions.allows_users_convert_electronic' | translate}}</div>
                </div>
              </div>
             </nz-tab>
          </nz-tabset>
        </mat-expansion-panel>
      </mat-accordion>
    </mat-card-content>

    <mat-card-actions class="text-center">
      <button mat-stroked-button color="primary" class="mr-3" (click)="onClickBtnCancel()" type="button">
        <mat-icon class="mr-0">cancel</mat-icon>
        {{'button.cancel' | translate}}
      </button>
      <button mat-raised-button type="submit" cdkFocusInitial color="primary">
        <mat-icon class="mr-0">save</mat-icon>
        {{'button.save' | translate}}
      </button>
    </mat-card-actions>
  </mat-card>
</form>

<ng-template #addGroupCustomer>
  <div style="display: flex; justify-content: space-between;">
    <div>
        <h2 mat-dialog-title>{{'new_permission_406.configure_customer_group' | translate}}</h2>

    </div>
    <div>
        <button  class="close" (click)="openConfirmDialog('close')">
            <mat-icon>close</mat-icon>
        </button>
    </div>
  </div>
  <div>
    <div style="margin-bottom: 16px;">
      <nz-input-group [nzSuffix]="suffixPartyInput">
        <input nz-input [(ngModel)]="inputInternalDocumentsValue" (input)="getParentContractNew($event)" (blur)="blurInput($event)"
               [nzAutocomplete]="autoInternalUserSearching" [ngModelOptions]="{ standalone: true }" placeholder="{{ 'new_permission_406.hintext_search_group_customer' | translate }}" #autocompleteInput id="inputUser1" />
        <nz-autocomplete #autoInternalUserSearching>
          <nz-auto-option *ngFor="let user of listGroupCustomer"
                          (selectionChange)="autocompleteInternalUserSelected($event, user)"
                          [nzValue]="''">
            <div class="d-flex">
              <span style="line-height: 20px">
                  {{ user.name }}
                </span>
            </div>
          </nz-auto-option>
        </nz-autocomplete>
      </nz-input-group>
      <ng-template #suffixPartyInput>
        <nz-spin *ngIf="nzCheckLoadingParty1" nzSimple [nzIndicator]="indicatorPartyInput"></nz-spin>
      </ng-template>
      <ng-template #indicatorPartyInput><i class="nz-icon-font" nz-icon nzType="loading"
                                           style="font-size: 24px"></i>
      </ng-template>
    </div>
    <h5>{{'new_permission_406.list_group' | translate}}</h5>
    <div class="table-container">
      <nz-table #groupCustomerTable [nzData]="newDataListGroupCustomer" [nzFrontPagination]="false" [nzShowPagination]="false" [nzNoResult]="'toastr_report.no_content' | translate"
      class="ant-table-no-placeholder-border-bottom " nzBordered>
        <thead>
          <tr>
            <th class="text-center sticky-header" nzWidth="50px">{{'STT' | translate}}</th>
            <th class="text-center sticky-header">{{'new_permission_406.customer_group' | translate}}</th>
            <th class="" nzWidth="40px"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let groupCustomer of groupCustomerTable.data; let i = index">
              <td class="text-center">{{ i + 1}}</td>
              <td [matTooltip]="groupCustomer.name"><div class="text-truncate name_group_customer">{{ groupCustomer.name }}</div></td>
              <td class="text-center"><i (click)="openConfirmDialog('delete', groupCustomer, i)" class="fa fa-trash" aria-hidden="true" matTooltip="{{ 'tooltips.delete' | translate }}"></i></td>
          </tr>
        </tbody>
      </nz-table>
    </div>
  </div>
  <div class="justify-content-center" mat-dialog-actions>
    <button mat-stroked-button color="primary" class="mr-3" (click)="openConfirmDialog('close')" type="button">
      <mat-icon class="mr-0">cancel</mat-icon>
      {{'button.cancel' | translate}}
    </button>
    <button mat-raised-button (click)="saveDataListGroupCustomer()" [disabled]="!changeCusomer || newDataListGroupCustomer.length === 0" cdkFocusInitial color="primary">
      <mat-icon class="mr-0">save</mat-icon>
      {{'button.save' | translate}}
    </button>

  </div>
</ng-template>

<ng-template #confirmPopup>
  <h2 mat-dialog-title style="margin-bottom: 0px !important;">
    {{'alert.confirm' | translate}}
    <button aria-label="Close" (click)="closeConfirmDialog()"
            class="close"
            type="button">
      <span aria-hidden="true">&times;</span>
    </button>
  </h2>
  <mat-divider></mat-divider>
  <div class="d-flex" style="gap: 8px;">
    <div class="col-2 pr-0" style="text-align: center;padding-left: 0px !important; padding-top: 15px;">
      <em class="fa fa-warning text-primary large"></em>
    </div>
    <div>
      <div *ngIf="confirmType == 'close'" style=" padding: 5px 7px 15px; font-size: medium; overflow-wrap: break-word;">
        {{ 'new_permission_406.customer_group_configuration_lost' | translate }}
      </div>
      <div *ngIf="confirmType == 'delete'" style=" padding: 5px 7px 15px; font-size: medium; overflow-wrap: break-word;">
        {{ 'new_permission_406.confirm_delete_permission_group' | translate }} <strong>{{dataDelete.name}}</strong>?
      </div>
    </div>
  </div>
  <div class="justify-content-center" mat-dialog-actions>
    <button mat-stroked-button (click)="closeConfirmDialog()" color="primary" cdkFocusInitial class="mr-3" type="button">
      <mat-icon class="mr-0">cancel</mat-icon>
      {{'button.ignore' | translate}}
    </button>
    <button mat-raised-button (click)="closeConfirmDialog('yes')"   color="primary">
      <mat-icon class="mr-0">save</mat-icon>
      {{'button.yes' | translate}}
    </button>
  </div>
</ng-template>
